(function paycheckRRHHModuleDefinition() {
    'use strict';

    angular.module('PaycheckRRHH', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'Process', 'DocumentViewer'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function paycheckRRHHConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('paycheck-rrhh-sign', {
                    url: "/PaycheckRRHH/Sign",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-sign.html'),
                    controller: 'PaycheckRRHHSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK MULTIPLE SIGN')
                });

                $stateProvider.state('paycheck-rrhh-detail', {
                    url: "/PaycheckRRHH/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-detail.html'),
                    controller: 'PaycheckRRHHDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK READ').or('PAYCHECK WRITE')
                });

                $stateProvider.state('paycheck-rrhh-edit', {
                    url: "/PaycheckRRHH/Edit/{id}",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-edit.html'),
                    controller: 'PaycheckRRHHEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK WRITE').or('PAYCHECK SIGN')
                });

                $stateProvider.state('paycheck-rrhh-add', {
                    url: "/PaycheckRRHH/Add",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-add.html'),
                    controller: 'PaycheckRRHHAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK WRITE')
                });

                $stateProvider.state('paycheck-rrhh-find', {
                    url: "/PaycheckRRHH/Find",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-find.html'),
                    controller: 'PaycheckRRHHFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK READ').or('PAYCHECK WRITE')
                });

                $stateProvider.state('paycheck-rrhh-find-pending', {
                    url: "/PaycheckRRHH/Find/SignPending",
                    templateUrl: config.resourceUrl('/views/paycheck-rrhh/paycheck-rrhh-find.html'),
                    controller: 'PaycheckRRHHFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK READ').or('PAYCHECK WRITE'),
                    params: { isSignPending: true }
                });
            }
        ]);
})();
